<template>
  <div class="page">
    <div style="margin-top: 50px;">
      <div class="item" @click="goPage('/esign-center-add')">
        <img src="@/assets/ic_add.png" alt="">
        <div class="name">入职新签</div>
      </div>
      <div class="item" @click="goPage('/esign-center-resign')">
        <img src="@/assets/ic_add.png" alt="">
        <div class="name">续签合同</div>
      </div>
      <div class="item" @click="goPage('/esign-center-delete')">
        <img src="@/assets/ic_add.png" alt="">
        <div class="name">离职证明</div>
      </div>
    </div>
    <bind-personnel ref="bindPersonnel" @success="loadData"></bind-personnel>
  </div>
</template>

<style scoped>
.page {
  box-sizing: border-box;
}

.item {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  background: white;
  padding: 20px;
  margin: 20px;
  border-radius: 5px;
}

.name {
  margin-left: 30px;
  font-size: 15px;
}

img {
  width: 60px;
}
</style>

<script>
import BindPersonnel from '@/components/BindPersonnel'
import mixinLoad from '@/mixin/mixin-load.js'

export default {
  name: 'EsignCenter',
  components: {BindPersonnel},
  mixins: [mixinLoad],
  data() {
    return {
      loading: true
    }
  },
  methods: {
    loadData() {
      this.loading = true
    },
    goPage(path) {
      this.$router.push({path});
    },
  },
  created() {
    Promise.all([this.preCheck()]).then(() => {
    })
    this.loadData()
  }
}
</script>
